import { Fragment, h } from "preact";
import { RouterProps } from "preact-router";
import { Container, ToastViewer } from "uitoolkit";
import { usePageTitle } from "hooks";
import { Sidebar } from "components/sidebar";

export function NotFoundPage(props: {} & RouterProps) {
    usePageTitle("Not found");

    return (
        <Fragment>
            <Container class="row grow maxheight-100vh overflow-y-hidden">
                <Sidebar />
                <Container class="flex-column overflow-y-auto grow">
                    <div style={{ paddingTop: "16px" }} />
                    <Container class="p-4 pt-0 bg-primary gap-16 flex-column grow maxwidth center">
                        <img src="/icons/favicon-32x32.png" />
                        <h1>Page not found</h1>
                        <p style={{ "color": "var(--text-secondary)" }}>Your machine overlord knows most things, but this is not one of them.</p>
                    </Container>
                </Container>
            </Container>
            <ToastViewer />
        </Fragment>
    );
}
